<ion-item lines="none" mode="md" class="item-resume">
  <ion-label color="grayDemon" class="promotion-summary">
    {{
      "Labels." + (promo.Bonificacion ? "bonus-summary" : "promotion-summary")
        | translate
    }}

    <ng-container
      *ngIf="
        Niveles.length > 0 &&
        (promo.TipoPromocion === 'DINAMICO' ||
          promo.TipoPromocion === 'BONIFICACION')
      "
    >
      <ion-text color="grayDemon" class="ion-float-right">
        {{ "Labels.level" | translate }}
        <ion-text color="correct">
          {{ advanceLevel().length }}
        </ion-text>
        {{ "Labels.the" | translate }}
        {{ Niveles.length }}
      </ion-text>
    </ng-container>
  </ion-label>

  <ion-icon
    slot="end"
    name="checkmark-circle-outline"
    [color]="isCheck ? 'correct' : 'grayDemon'"
  ></ion-icon>
</ion-item>
